import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';

import { Observable } from 'rxjs';

import { decodeRedirectUrlFromQueryParam, getCookie } from '@shared/utils';

@Injectable({
  providedIn: 'root'
})
export class LoginGuardService {
  constructor(private router: Router) {}
  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | boolean | Promise<boolean | UrlTree> {
    const redirectUrl = decodeRedirectUrlFromQueryParam(route.queryParams?.redirect);

    // access token check
    return getCookie('accessToken') ? this.router.navigate([redirectUrl ? redirectUrl : '/']) : true;
  }
}
export const LoginGuard: CanActivateFn = (route) => {
  return inject(LoginGuardService).canActivate(route);
};
